module.exports = __webpack_public_path__ + "f59bfbe77eef046c0bceeff520eb7f7e.png";